import { useEffect, useState } from "react";
import Input from "../components/fields/Input";
import DefaultButton from "../components/buttons/DefaultButton";
import Logo from "../components/Logo";
import { UserService } from "../services/UserService";

export default function Login() {
  const [matricula, setMatricula] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("name");
    localStorage.removeItem("username");
    localStorage.removeItem("isMaster");
    localStorage.removeItem("roleName");
    localStorage.removeItem("roleType");
  }, []);

  const handleLogin = async () => {
    try {
      localStorage.removeItem("termsAccepted");

      const userService = new UserService();
      const response = await userService.auth({
        username: matricula,
        password: senha,
      });

      if (response.data.isBlocked) {
        setError(
          `Você está bloqueado de acessar o sistema até ${response.data.blockedUntilFormatted}`
        );
        return;
      }

      // Save access token to localStorage
      localStorage.setItem("authToken", response.data.accessToken);
      localStorage.setItem("name", response.data.name);
      localStorage.setItem("username", response.data.username);
      localStorage.setItem("isMaster", response.data.isMaster);
      localStorage.setItem("roleName", response.data.role?.name);
      localStorage.setItem("roleType", response.data.role?.type);

      // Redirect based on role
      if (response.data.role?.name === "Comando") {
        window.location.href = "/admin/reservations";
        return;
      }

      if (response.data.role?.type === "ADMIN") {
        window.location.href = "/admin";
        return;
      }

      window.location.href = "/";
    } catch (error) {
      // Display error message
      setError(error?.message || "Credenciais inválidas. Tente novamente.");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="container">
      <div className="text-center pt-5">
        <Logo className="mb-4" />
        <div className="px-4">
          {error && <div className="alert alert-danger">{error}</div>}
          <Input
            label="Matrícula"
            value={matricula}
            onChange={(e) => setMatricula(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <Input
            label="Senha"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <DefaultButton onClick={handleLogin}>Entrar</DefaultButton>
        </div>
      </div>
    </div>
  );
}
